module.exports = __webpack_public_path__ + "static/img/27.7f420a16.jpg";